export const DATE_FIELDS = ['arrival_date', 'departure_date'];
export const GUEST_FIELDS = [
  'first_name',
  'last_name',
  'visitor_phone',
  'visitor_email',
  'visit_reason',
  'checkin_instructions',
];
